/* Components */
import Header from "../../components/common/Header";
import { getAgencyContactProInfos, getAgencyProInfos } from "../../api/admin/agencyReq";
import { useEffect, useState } from "react";
import useData from "../../hooks/useData";
import useAuth from "../../hooks/useAuth";
import { getActivityList } from "../../api/admin/activityReq";
import { getLegalFormList } from "../../api/admin/legalFormListReq";
import FormAgencyGeneral from "../../forms/admin/agency/FormAgencyGeneral";
import FormAgencyContacts from "../../forms/admin/agency/FormAgencyContacts";
import { safeJwtDecode } from "../../helper/jwtHelper";
import { getCountryList } from "../../api/admin/addressReq";
import Icon from "../../components/common/Icon";
import ViewDeceasedOtherInfos from "../deceased/visualisation pages/ViewDeceasedOtherInfos";


export default function Agency() {

    const { auth } = useAuth();
    const decodedToken = safeJwtDecode(auth.token);
    const agencyId = decodedToken?.agency;
    const token = auth.token;
    const { setActivityList, countryList, setCountryList } = useData();
    const { setLegalFormList } = useData();
    const { agencyMainInfos, setAgencyMainInfos, agencyContact, setAgencyContact } = useData();
    const [showMainInfosModal, setShowMainInfosModal] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);

    const apiActivityList = async () => {
        const response = await getActivityList(token)
        setActivityList(response)
    }

    const apiLegalFormList = async () => {
        const response = await getLegalFormList(token)
        setLegalFormList(response)
    }

    const apiCountryList = async () => {
        const response = await getCountryList(token)
        setCountryList(response)
    }

    const apiAgencyContact = async () => {
        const response = await getAgencyContactProInfos(token, agencyId);
        setAgencyContact(response);
    }

    const agencyMain = async () => {
        const response = await getAgencyProInfos(token, agencyId);
        setAgencyMainInfos(response);
    }

    useEffect(() => {
        agencyMain()
        apiAgencyContact()
        apiActivityList()
        apiLegalFormList()
    }, [agencyId]);

    useEffect(() => {
        apiCountryList()
    }, [token]);

    const handleAgencyMainForm = () => {
        setShowMainInfosModal(true)
    }

    const handleAgencyContactForm = () => {
        setShowContactModal(true)
    }

    const selectedCountry = countryList?.find(country => country?.code === agencyContact?.country)?.name;

    return (
        <main className="admin">
            <Header parent="Tableau de bord"
                location="Agence"
                slug="/"
            />
            {showMainInfosModal &&
                <div className="modal main-infos">
                    <FormAgencyGeneral setShowModal={setShowMainInfosModal} legend="Informations générales" />
                </div>
            }
            {showContactModal &&
                <div className="modal contact">
                    <FormAgencyContacts agencyContactInfos={agencyContact} apiAgencyContacts={apiAgencyContact} setShowModal={setShowContactModal} legend="Contacts" />
                </div>
            }
            <form>
                <fieldset>
                    <Icon span="Informations générales" source="fa fa-home"/>
                        <div className="form-input">
                            <label>Nom</label>
                            <span>{agencyMainInfos?.name}</span>
                        </div>
                        <div className="form-input">
                            <label>Siège social</label>
                            <span>{agencyMainInfos?.headquarters === true ? "Oui" : "Non"}</span>
                        </div>
                        <div className="form-input">
                            <label>Ensemble</label>
                            <span>{agencyMainInfos?.isEnsemble === true ? "Oui" : "Non"}</span>
                        </div>
                        <div className="form-input">
                            <label>Forme juridique</label>
                            <span>{agencyMainInfos?.legalForm?.name}</span>
                        </div>
                        <div className="form-input">
                            <label>Code d'habilitation</label>
                            <span>{agencyMainInfos?.authorizationCode}</span>
                        </div>
                        <div className="form-input">
                            <label>Date d'immatriculation</label>
                            <span>{agencyMainInfos?.registrationDate}</span>
                        </div>
                        <div className="form-input">
                            <label>Siret</label>
                            <span>{agencyMainInfos?.siret}</span>
                        </div>
                        <div className="form-input">
                            <label>TVA intracommunautaire</label>
                            <span>{agencyMainInfos?.tvaNumber}</span>
                        </div>
                        <div className="form-input">
                            <label>Capital</label>
                            <span>{agencyMainInfos?.capital}</span>
                        </div>
                        <div className="form-input">
                            <label>Effectif</label>
                            <span>{agencyMainInfos?.workforce}</span>
                        </div>
                        <div className="form-input">
                            <label>Horaires d'ouverture</label>
                            <span>{agencyMainInfos?.hours}</span>
                        </div>
                        <div className="form-input">
                            <label id="activities-label">Activités</label>
                            <div className="agency-activity">
                                {agencyMainInfos?.activity && agencyMainInfos?.activity.map(
                                    (activity => (
                                        <p key={activity?.id}>{activity?.name}</p>
                                    ))
                                )}
                            </div>
                        </div>
                    <div className="buttons-container">
                        <button type="button" className="red-button" onClick={handleAgencyMainForm}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                    </div>
                </fieldset>
                <fieldset>
                    <Icon span="Contacts - Codes postaux" source="fa fa-envelope"/>
                    <div className="form-input">
                        <label>Adresse postale</label>
                        <span>{agencyContact?.address}</span>
                    </div>
                    <div className="form-input">
                        <label>Complément d'adresse</label>
                        <span>{agencyContact?.addressComp}</span>
                    </div>
                    <div className="form-input">
                        <label>Code postal</label>
                        <span>{agencyContact?.zipcode}</span>
                    </div>
                    <div className="form-input">
                        <label>Ville</label>
                        <span>{agencyContact?.city}</span>
                    </div>
                    <div className="form-input">
                        <label>Pays</label>
                        <span>{selectedCountry}</span>
                    </div>
                    <div className="form-input">
                        <label>Codes postaux additionnels (séparés par une virgule)</label>
                        <span>{agencyContact?.additionalZipcodes}</span>
                    </div>
                    <div className="form-input">
                        <label>Latitude</label>
                        <span>{agencyContact?.latitude}</span>
                    </div>
                    <div className="form-input">
                        <label>Longitude</label>
                        <span>{agencyContact?.longitude}</span>
                    </div>
                    <div className="form-input">
                        <label>Téléphone</label>
                        <span>{agencyContact?.phone}</span>
                    </div>
                    <div className="form-input">
                        <label>Téléphone mobile</label>
                        <span>{agencyContact?.mobile}</span>
                    </div>
                    <div className="form-input">
                        <label>Email</label>
                        <span>{agencyContact?.email}</span>
                    </div>
                    <div className="form-input">
                        <label>Site Internet</label>
                        <span>{agencyContact?.website}</span>
                    </div>
                    <div className="form-input">
                        <label>A une adresse pour les condoléances ?</label>
                        <span>{agencyContact?.hasCondolenceEmail == true ? "Oui" : "Non"}</span>
                    </div>
                    {agencyContact?.hasCondolenceEmail &&
                        <div className="form-input">
                            <label>Email pour les condoléances</label>
                            <span>{agencyContact?.condolenceEmail}</span>
                        </div>
                    }
                    <div className="buttons-container">
                        <button type="button" className="red-button" onClick={handleAgencyContactForm}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                    </div>
                </fieldset>
                <ViewDeceasedOtherInfos legend="Logo de l'agence" />
            </form>
        </main>
    )
}